// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Bku8vDKpw1IB1vRN5Skd {
    cursor: default;
    border-radius: 8px;
    border: 1px solid transparent;
    transition: all 0.2s ease-in-out;
    margin-bottom: 8px;
}

.Bku8vDKpw1IB1vRN5Skd.BbOXjjfDYXesULyJDnto {
    cursor: pointer;
}

.Bku8vDKpw1IB1vRN5Skd.BbOXjjfDYXesULyJDnto:hover {
    border-color: #e0e0e0;
    box-shadow: 0 2px 8px rgb(0 0 0 / 10%);
    transform: translateY(-1px);
}

.jSrarMIcZfqs7r2bxORI {
    display: flex;
    align-items: center;
    gap: 12px;
}

.iAfwGbmunBomMd9BoDBS {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
}

.QUlRLm4s0a7GB8TWw8_c {
    font-size: 18px;
}

.OoYnHilc1ryPuP1ZVOtm {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
}

._mGyRJXRjkwe2G7_S3UI {
    margin: 0;
}

.BlxS5lG6Ip6iahciJ4KF {
    margin: 0;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Shared/ConfirmationDetailCard/ConfirmationDetailCard.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".wrapper {\n    cursor: default;\n    border-radius: 8px;\n    border: 1px solid transparent;\n    transition: all 0.2s ease-in-out;\n    margin-bottom: 8px;\n}\n\n.wrapper.clickable {\n    cursor: pointer;\n}\n\n.wrapper.clickable:hover {\n    border-color: #e0e0e0;\n    box-shadow: 0 2px 8px rgb(0 0 0 / 10%);\n    transform: translateY(-1px);\n}\n\n.contentWrapper {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.iconContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 24px;\n}\n\n.icon {\n    font-size: 18px;\n}\n\n.textContainer {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.title {\n    margin: 0;\n}\n\n.content {\n    margin: 0;\n    font-weight: 600;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Bku8vDKpw1IB1vRN5Skd`,
	"clickable": `BbOXjjfDYXesULyJDnto`,
	"contentWrapper": `jSrarMIcZfqs7r2bxORI`,
	"iconContainer": `iAfwGbmunBomMd9BoDBS`,
	"icon": `QUlRLm4s0a7GB8TWw8_c`,
	"textContainer": `OoYnHilc1ryPuP1ZVOtm`,
	"title": `_mGyRJXRjkwe2G7_S3UI`,
	"content": `BlxS5lG6Ip6iahciJ4KF`
};
export default ___CSS_LOADER_EXPORT___;
